import { IBreadcrumbItem } from '@bridebook/web/app-shared/lib/types';

/**
 * See required fields of the schema:
 * https://schema.org/BreadcrumbList
 *
 * Schema validator: https://developers.google.com/search/docs/advanced/structured-data
 */
interface IMicroData {
  '@context': 'https://schema.org';
  '@type': 'BreadcrumbList';
  itemListElement: {
    '@type': 'ListItem';
    position: number;
    name: string;
    item: string;
  }[];
}

export const generateBreadcrumbListMicrodata = (
  _breadcrumbItems: IBreadcrumbItem[],
): IMicroData | null => {
  const breadcrumbItems = _breadcrumbItems.filter((item) => !!item.path);

  if (breadcrumbItems.length === 0) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.path as string,
    })),
  };
};
